/*
 * @Author: jiaoxiaojie jiaoxiaojie666@sina.com
 * @Date: 2022-05-17 21:58:18
 * @LastEditors: jiaoxiaojie jiaoxiaojie666@sina.com
 * @LastEditTime: 2023-11-21 14:05:41
 * @FilePath: \main\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Approve from '@/views/Approve'
import Approvainfo from '@/views/Approvainfo'
import Userfeedback from '@/views/Userfeedback'
import Notfound from '@/views/Notfound'
import Notauth from '@/views/Notauth'
import Otherpage from '@/views/Otherpage'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const router = new VueRouter({
  routes: [{
    path: '/Approve',
    name: 'Approve',
    component: Approve
  },
  {
    path: '/Approvainfo',
    name: 'Approvainfo',
    component: Approvainfo
  },
  {
    path: '/Notauth',
    name: 'Notauth',
    component: Notauth
  },
  {
    path: '/Userfeedback',
    name: 'Userfeedback',
    component: Userfeedback
  },
  {
    path: '/Notfound',
    name: 'Notfound',
    component: Notfound
  },
  {
    path: '/Otherpage',
    name: 'Otherpage',
    component: Otherpage
  }
  ]
})

router.beforeEach((to, from, next) => {
  // 请求"login"就直接通过
  // if (to.path === '/login') {
  //   return next()
  // }
  // // 请求"非login"，就判断token
  // var token = window.sessionStorage.getItem('token')
  // if (!token) {
  //   return next('/login')
  // }
  next() // 请继续你的旅行
})
export default router
